// Auto-generated by the generator
// Don't manually edit this file

// @flow

import {setLoading} from './setLoading'
import {setCities} from './setCities'
import {setDistricts} from './setDistricts'
import {setSelectedCity} from './setSelectedCity'

export const hospitalActions = {
  setLoading,
  setCities,
  setDistricts,
  setSelectedCity,
}
